import { useParams } from 'react-router-dom';
import AccountAge from './Age';
import AccountAgree from './Agree';
import AccountForm from './Form';
import { useCallback } from 'react';
import { userSignUp } from 'src/services/api';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useModal } from 'src/ModalContext';
import { useTranslation } from 'react-i18next';

const Components: {
  [key: string]: (data: AccountProcessProps) => JSX.Element;
} = {
  age: AccountAge,
  agree: AccountAgree,
  form: AccountForm,
};

export default function Account(): JSX.Element {
  const history = useCustomHistory();
  const { t } = useTranslation();
  const { showModal } = useModal();
  const { step } = useParams() as {
    step: string;
  };

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      userSignUp({
        email: e.target.email.value.trim(),
        password: e.target.password.value,
        country: e.target.country.value.trim(),
        birth: e.target.birth.value.trim(),
        termsAllowed: e.target.termsAllowed.checked,
        privacyPolicyAllowed: e.target.privacyPolicyAllowed.checked,
      })
        .then((res) => {
          history.push('/account/complete', res as any);
        })
        .catch((e) => {
          let message = e.message;
          switch (e.response.status) {
            case 400:
              message = t('account/form/user_already_exists');
              break;
            case 422:
              message = t('account/form/server_validation_error');
              break;
          }
          showModal({
            message,
            success() {
              return;
            },
          });
        });
    },
    [history],
  );

  return (
    <div className="">
      <form onSubmit={onSubmit}>
        {Object.keys(Components).map(function (key) {
          const StepComponent = Components[key];
          return <StepComponent key={key} isShow={step === key} />;
        })}
        {/* {StepComponent && <StepComponent formHooks={formHooks} />} */}
      </form>
    </div>
  );
}
